import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var LightbulbIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 4a1 1 0 01-1-1V2a1 1 0 112 0v1a1 1 0 01-1 1zm0 3a4 4 0 00-4 4c0 1.511.846 2.18 1.597 2.773.22.174.43.34.61.52.417.417.653.848.745 1.377.018.105.03.216.038.33h2.036c.056-.59.23-1.171.767-1.707.18-.18.39-.346.61-.52C15.153 13.18 16 12.511 16 11a4 4 0 00-4-4zm3 10a1 1 0 01-1 1h-4a1 1 0 01-1-1l.002-.342c.001-.107.002-.199.001-.302a2.193 2.193 0 00-.021-.343c-.014-.076-.028-.144-.19-.306-.024-.025-.083-.068-.168-.13C8.002 15.129 6 13.68 6 11a6 6 0 1112 0c0 2.68-2.002 4.128-2.624 4.578a1.91 1.91 0 00-.169.13.503.503 0 00-.164.3c-.039.194-.043.456-.043.992zM4 12a1 1 0 100-2H3a1 1 0 100 2h1zm2.414-6.172a1 1 0 01-1.414 0l-.707-.707a1 1 0 111.414-1.414l.707.707a1 1 0 010 1.414zm13.414-.707l-.707.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 111.414 1.414zM22 11a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM9 20a1 1 0 011-1h4a1 1 0 110 2h-.5a1 1 0 01-1 1h-1a1 1 0 01-1-1H10a1 1 0 01-1-1z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
LightbulbIcon.isCarinaIcon = true;
export default LightbulbIcon;
